export const ACTIVITY_ACTION_TYPES = {
  ACTIVITY_SET_DATA_BY_KEY: 'ACTIVITY_SET_DATA_BY_KEY',
  ACTIVITY_CHANGE_PROCESSING: 'ACTIVITY_CHANGE_PROCESSING',
  ACTIVITY_CLEAR_STATE: 'ACTIVITY_CLEAR_STATE',
};

export function setDataByKey(data, stateKeyForDataSaving) {
  return {
    type: ACTIVITY_ACTION_TYPES.ACTIVITY_SET_DATA_BY_KEY,
    payload: {
      data,
      stateKeyForDataSaving,
    },
  };
}

export function clearDataState(clearedKey) {
  return {
    type: ACTIVITY_ACTION_TYPES.ACTIVITY_CLEAR_STATE,
    payload: {
      clearedKey,
    },
  };
}

export function changeDataProcessingState(newState, processingDestination) {
  return {
    type: ACTIVITY_ACTION_TYPES.ACTIVITY_CHANGE_PROCESSING,
    payload: { newState, processingDestination },
  };
}

export function getData(
  pageObject,
  stateKeyForDataSaving,
  methodUrl,
  processingKey,
  page,
  pageSize,
) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeDataProcessingState(true, 'processing'));

    const url =
      page && pageSize
        ? `${methodUrl}?page=${page}&pageSize=${pageSize}`
        : methodUrl;

    const response = await axios.get(url);

    dispatch(changeDataProcessingState(false, 'processing'));

    if (!response || response.code !== 'success' || !pageObject.mounted) {
      return response;
    }

    const { data } = response;
    dispatch(setDataByKey(data, stateKeyForDataSaving));

    return response;
  };
}

export function getActivityNew(pageObject, stateKeyForDataSaving, methodUrl) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeDataProcessingState(true, 'processingActivityNew'));
    const response = await axios.get(methodUrl);
    dispatch(changeDataProcessingState(false, 'processingActivityNew'));

    if (!response || response.code !== 'success' || !pageObject.mounted) {
      return response;
    }

    const { data } = response;
    dispatch(setDataByKey(data, stateKeyForDataSaving));
    return response;
  };
}

export const accessSendResponse =
  (url) =>
  async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    const response = await axios.put(url);

    if (!response || response.code !== 'success') {
      return response;
    }
  };
